import { render, staticRenderFns } from "./DialogTransportDocumentForm.vue?vue&type=template&id=a88b1e86&scoped=true"
import script from "./DialogTransportDocumentForm.vue?vue&type=script&lang=js"
export * from "./DialogTransportDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DialogTransportDocumentForm.vue?vue&type=style&index=0&id=a88b1e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b1e86",
  null
  
)

export default component.exports